import { FC, useState, ReactNode } from 'react'

import { Box, useTheme, useMediaQuery } from '@mui/material'

import { App } from '../../typings/App'

import { Header } from '../Header'

import { Drawer } from '../Drawer'

interface Props {
    apps?: App[]
    children?: ReactNode
}

export const Layout: FC<Props> = ({
    apps,
    children
}) => {
    const [drawerOpen, setDrawerOpen] = useState(false)
    const theme = useTheme()
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'), { noSsr: true })
    
    const handleDrawerClose = () => {
        if (isMobile) {
            setDrawerOpen(false); // solo cerrar si es móvil
        }
    }

    return (
        <Box sx={{ display: 'flex', width: '100%' }}>
            <Header onMenu={() => setDrawerOpen(!drawerOpen)} showMenu={isMobile} />
            <Drawer
                isOpen={!(isMobile && !drawerOpen)}
                apps={apps}
                onClose={handleDrawerClose}
            />
            <Box
                component="main"
                sx={{
                    flexGrow: 1,
                    minWidth: 0,
                    width: '100%',
                    p: (muiTheme) => muiTheme.spacing(3, 2)
                }}
            >
                <Box sx={theme.mixins.toolbar} />
                { children }
            </Box>
        </Box>
    )
}
